import type { ApplePaySession } from 'braintree-web';
import type { ClientSettings } from '../typings/configuration.types';
import type { KlarnaExpressButtonApi, KlarnaPaymentsApi } from '../typings/klarna.types';

export const NO_KLARNA_EXPRESS_BUTTON_API_ERROR = 'Klarna Express Button API is not available on window.Klarna';
export const NO_KLARNA_PAYMENTS_API_ERROR = 'Klarna Payments API is not available on window.Klarna';

export const isKlarnaExpressButtonApi = (value: unknown): value is KlarnaExpressButtonApi => {
    return typeof value === 'object' && value !== null && 'ExpressButton' in value;
};

export const isKlarnaPaymentsApi = (value: unknown): value is KlarnaPaymentsApi => {
    return typeof value === 'object' && value !== null && 'Payments' in value;
};

export const getKlarnaExpressButtonApi = (): KlarnaExpressButtonApi => {
    const { Klarna } = window;
    if (!isKlarnaExpressButtonApi(Klarna)) {
        throw new Error(NO_KLARNA_EXPRESS_BUTTON_API_ERROR);
    }
    return Klarna;
};

export const getKlarnaPaymentsApi = (): KlarnaPaymentsApi => {
    const { Klarna } = window;
    if (!isKlarnaPaymentsApi(Klarna)) {
        throw new Error(NO_KLARNA_PAYMENTS_API_ERROR);
    }
    return Klarna;
};

export const getApplePaySession = (): typeof ApplePaySession | undefined => {
    return window.ApplePaySession;
};

export const setForterToken = (token: string): void => {
    window.forterToken = token;
};

export const setClientSettings = (settings: ClientSettings): void => {
    window.clientSettings = settings;
};

export const setExperiments = (experiments: Window['experiments']): void => {
    window.experiments = experiments;
};

export const setKlarnaExpressButtonAsyncCallback = (callback: () => void): void => {
    window.klarnaExpressButtonAsyncCallback = callback;
};
